<template>
  <modal content-class="marketing-automation-edit"
         title="Editar nome"
         :value="showing"
         :maxWidth="500"
         @input="emitShowing">

    <app-form @submit="edit">
      <text-field class="marketing-automation-edit-name"
                  v-model="form.name"
                  label="Nome da automação"
                  name="Nome da automação"
                  help="help"
                  validate="required" />

      <button class="marketing-automation-edit-action btn btn-primary btn-round"
              type="submit">
        Editar
      </button>
    </app-form>

  </modal>
</template>

<script>
import EventBus from "@packages/event-bus/index";
import TextField from "@components/form/TextField.vue";
import AppForm from "@components/form/Form.vue";
import Modal from "@components/generic/Modal.vue";

export default {
  components: {
    Modal,
    AppForm,
    TextField,
  },

  props: {
    showing: {
      type: Boolean,
      default: false,
    },
    automationId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      form: {
        name: "",
      },
    };
  },

  created() {
    this.form.name = this.name;
  },

  methods: {
    emitShowing(showing) {
      this.$emit("update:showing", showing);
    },
    async edit() {
      const editedAutomation = await this.$api.marketing.automation.flow.edit({
        automationId: this.automationId,
        name: this.form.name,
      });

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: "Nome editado com sucesso!",
      });

      this.$emit("edited", editedAutomation.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-edit {
  .marketing-automation-edit-name {
    margin-bottom: 40px;
  }

  .marketing-automation-edit-action {
    margin: 0 auto;
    display: block;
  }
}
</style>
